import { Injectable } from '@angular/core';
import { FormlyFieldConfig } from '@ngx-formly/core';

import { SpecialValidators } from 'ish-shared/forms/validators/special-validators';

import { FieldLibraryConfiguration } from './field-library-configuration';

/**
 * Address Line 1 (usually street & number), required by default
 */
@Injectable()
export class AddressLine1Configuration extends FieldLibraryConfiguration {
  id = 'addressLine1';

  getFieldConfig(): FormlyFieldConfig {
    return {
      type: 'ish-text-input-field',
      props: {
        label: 'account.address.street.label',
        required: true,
        maxLength: 60,
      },
      validators: {
        validation: [SpecialValidators.noOnlyWhiteSpaces],
      },
      validation: {
        messages: {
          required: 'account.address.address1.error.required',
          noOnlyWhiteSpaces: 'account.address.address1.error.required',
        },
      },
    };
  }
}
